import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AzureMap,
  AzureMapDataSourceProvider,
  AzureMapFeature,
  AzureMapLayerProvider,
  AzureMapsProvider,
  AzureMapHtmlMarker,
  IAzureMapOptions,
  AzureMapPopup,
} from "react-azure-maps";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import {
  AuthenticationType,
  data,
  MapMouseEvent,
  PopupOptions,
} from "azure-maps-control";
import * as atlas from "azure-maps-control";

import { key } from "./../CGOHome/key";

import marker3 from "../../Assests/marker3.svg";
import marker1 from "../../Assests/marker1.svg";
import products from "../../Assests/marker2.svg";
import capacity from "../../Assests/NewMarker2.svg";
import inBoundLine from "../../Assests/inbound-line.svg";
import locator from "../../Assests/locator.svg";

//
import processingPlant from "../../Assests/processing-plant.svg";
import processingPlantAdd from "../../Assests/processing-plant-add1.png";
import processingPlantCapacity from "../../Assests/processing-plant-capacity.svg";
import processingPlantRemove from "../../Assests/processing-plant-remove.svg";
import packagingPlant1 from "../../Assests/packaging-plant-blue.svg";
import packagingPlant2 from "../../Assests/packaging-plant-green1.png";
import packagingPlantCapacity from "../../Assests/packaging-plant-capacity.svg";
import packagingPlantRemove from "../../Assests/packaging-plant-remove.svg";
import suppliersIcon from "../../Assests/supplier.svg";
import supplierMap from "../../Assests/supplier.svg";
import inBoundtoSupplier from "../../Assests/inbound-to-supplier.svg";
import "./style.css";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { popup } from "react";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import {
  API_BASE_URL,
  GET_AZURE_MAP_DATA,
  NUTRITION_GET_AZURE_MAP_DATA,
  CGO_AZUREMAPS_GET_API,
  LONG_AZUREMAPS_GET_API,
  LONG_SUMMARY_COST_PER_DASHBOARD_API,
} from "../../Utils/Config";
import { getRequest } from "../../Services/AxiosConfiguration";
import { red } from "@mui/material/colors";
import Loader from "../../Components/Modals/Loader";
import {
  displayDashboardSummaryCost,
  displayDashboardSummaryCostError,
  displayDashboardSummaryCostSuccess,
} from "../../Redux/Actions/InputData";
let folderModuleName = "module1";

export default function LongTermHome() {
  const [resultData, setResultData] = useState({});
  const [nutritionResultData, setNUTRITIONResultData] = useState({});
  const [bubbleWidth, setBubbleWidth] = useState(40);
  const [bubbleHeight, setBubbleHeight] = useState(40);
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(true);
  const [show3, setShow3] = useState(true);
  const [show4, setShow4] = useState(true);
  const [vendorList, setVendorList] = useState([]);

  const [SFGList, setSFGList] = useState([]);
  const [RMPMList, setRMPMList] = useState([]);
  const [processingList, setProcessingList] = useState([]);
  const [packagingList, setPackagingList] = useState([]);
  const [formatList, setFormatList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [depotList, setDepotList] = useState([]);
  const [flagList, setFlagList] = useState([]);
  const [vendorSelected, setVendorSelected] = useState([]);
  const [SFGSelected, setSFGSelected] = useState([]);
  const [RMPMSelected, setRMPMSelected] = useState([]);
  const [processingSelected, setProcessingSelected] = useState([]);
  const [packagingSelected, setPackagingSelected] = useState([]);
  const [formatSelected, setFormatSelected] = useState([]);
  const [productSelected, setProductSelected] = useState([]);
  const [depotSelected, setDepotSelected] = useState([]);
  const [flagSelected, setFlagSelected] = useState([]);
  const [filterTableData, setFilterTableData] = useState([]);
  const [viewDetail, setViewDetail] = useState(false);
  const [currentDetail, setCurrentDetail] = useState({});
  const dispatch = useDispatch();
  // suren
  //legends show hide
  const [showLegendDetails, setshowLegendDetails] = useState(false);

  //map filters show hid
  const [showMapFiltersDetails, setshowMapFiltersDetails] = useState(false);

  const { selectedScenarioData } = useSelector(
    (state) => state.InputDataReducers
  );
  console.log(
    selectedScenarioData?.scenario === "BaseLine",
    "selectedScenarioData"
  );

  // Factory section handle change

  const [proPlant, setProPlant] = useState(true);
  const [proPlantAdd, setProPlantAdd] = useState(true);
  const [proPlantCapacityAdd, setProPlantCapacityAdd] = useState(true);
  const [proPlantRemove, setProPlantRemove] = useState(true);

  //  Hide and show Factory section in Legend

  const [proPlantShow, setProPlantShow] = useState(false);
  const [proPlantAddShow, setProPlantAddShow] = useState(false);
  const [proPlantCapacityAddShow, setProPlantCapacityAddShow] = useState(false);
  const [proPlantRemoveShow, setProPlantRemoveShow] = useState(false);

  const handleProPlant = (e) => {
    // setShow1(e.target.checked);
    setProPlant(e.target.checked);
  };

  const handleProPlantAdd = (e) => {
    // setShow1(e.target.checked);
    setProPlantAdd(e.target.checked);
  };

  const handleProPlantCapacityAdd = (e) => {
    // setShow1(e.target.checked);
    setProPlantCapacityAdd(e.target.checked);
  };

  const handleProPlantRemove = (e) => {
    // setShow1(e.target.checked);
    setProPlantRemove(e.target.checked);
  };

  // Packaging section handle change

  const [packPlant, setPackPlant] = useState(true);
  const [packPlantAdd, setPackPlantAdd] = useState(true);
  const [packPlantCapacityAdd, setPackPlantCapacityAdd] = useState(true);
  const [packPlantRemove, setPackPlantRemove] = useState(true);

  // Hide and show Packaging section in Legend

  const [packPlantShow, setPackPlantShow] = useState(false);
  const [packPlantAddShow, setPackPlantAddShow] = useState(false);
  const [packPlantCapacityAddShow, setPackPlantCapacityAddShow] =
    useState(false);
  const [packPlantRemoveShow, setPackPlantRemoveShow] = useState(false);
  const [depotShow, setDepotShow] = useState(false);
  const [supplierShow, setSupplierShow] = useState(false);

  const handlePackPlant = (e) => {
    // setShow2(e.target.checked);
    setPackPlant(e.target.checked);
  };

  const handlePackPlantAdd = (e) => {
    // setShow2(e.target.checked);
    setPackPlantAdd(e.target.checked);
  };

  const handlePackPlantCapacityAdd = (e) => {
    // setShow2(e.target.checked);
    setPackPlantCapacityAdd(e.target.checked);
  };

  const handlePackPlantRemove = (e) => {
    // setShow2(e.target.checked);
    setPackPlantRemove(e.target.checked);
  };

  const selectedUsecaseId = useSelector(
    (state) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId
  );

  const selectedFolderId = useSelector(
    (state) => state.InputDataReducers.selectedFolderId
  );

  const selectedFolderData = useSelector(
    (state) => state.InputDataReducers.selectedFolderData
  );

  folderModuleName = selectedFolderData?.folder?.slice(0, 7);

  const selectedScnarioId = useSelector(
    (state) => state.InputDataReducers.selectedScenarioId
  );

  useEffect(() => {
    setshowMapFiltersDetails(false);
    setshowLegendDetails(false);
    setProPlantShow(false);
    setProPlantAddShow(false);
    setProPlantCapacityAddShow(false);
    setProPlantRemoveShow(false);
    setPackPlantShow(false);
    setPackPlantAddShow(false);
    setPackPlantCapacityAddShow(false);
    setPackPlantRemoveShow(false);
    setDepotShow(false);
    setSupplierShow(false);
  }, [selectedFolderData, selectedScnarioId]);

  const selectedTimeId = useSelector(
    (state) => state.InputDataReducers.selectedTimeId
  );

  const mapPointClicked = (det, heading, imgUrl) => {
    console.log("map ddetais", det);
    if (heading === "Depot") {
      setDepotSelected([
        {
          key: det.text,
          value: det.text,
        },
      ]);
    } else if (heading === "Packaging Plant") {
      setPackagingSelected([
        {
          key: det.text,
          value: det.text,
        },
      ]);
    } else if (heading === "Processing Plant") {
      setProcessingSelected([
        {
          key: det.text,
          value: det.text,
        },
      ]);
    } else {
      setVendorSelected([
        {
          key: det.text,
          value: det.text,
        },
      ]);
    }
    setshowLegendDetails(false);
    setshowMapFiltersDetails(true);
    setViewDetail(true);
    setCurrentDetail({ ...det, heading: heading, imgUrl: imgUrl });
    // setSelectedFactory(det.factory_Code);
    // setSelectedFactory("ABC")
  };

  useEffect(() => {
    getAzureMapData(selectedFolderId, selectedScnarioId);
    getSummaryCostForDashboard(selectedFolderId, selectedScnarioId);
  }, [selectedFolderId, selectedScnarioId]);
  //let resultData={};
  const getAzureMapData = async (folder_id, scenarioId) => {
    const urls = API_BASE_URL + LONG_AZUREMAPS_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    await getRequest(
      urls,
      {
        folder_id: folder_id,
        scenario_id: scenarioId,
        Time_Period: "Time_Period",
        moduleKey: folderModuleName ? folderModuleName : "0",
      },
      header
    )
      .then((response) => {
        console.log("Responseddddddd: ", response);

        let result = response.data;
        setResultData(result);
        setFilterTableData(result?.azureMapsFilterModel);
        let vcList = [],
          sfgList = [],
          RMPMList = [],
          ProcessingList = [],
          PackagingList = [],
          FormatList = [],
          productList = [],
          DepotList = [],
          plantflagList = [];
        result?.azureMapsFilterModel?.forEach((each) => {
          if (each.vendor_Code) {
            if (!vcList.some((item) => item.key === each.vendor_Code)) {
              vcList.push({ key: each.vendor_Code, value: each.vendor_Code });
            }
          }
          if (each.sfG_Code) {
            if (!sfgList.some((item) => item.key === each.sfG_Code)) {
              sfgList.push({ key: each.sfG_Code, value: each.sfG_Code });
            }
          }
          if (each.rM_PM_MI_Type) {
            if (!RMPMList.some((item) => item.key === each.rM_PM_MI_Type)) {
              RMPMList.push({
                key: each.rM_PM_MI_Type,
                value: each.rM_PM_MI_Type,
              });
            }
          }
          if (each.processing_Plant_Code) {
            if (
              !ProcessingList.some(
                (item) => item.key === each.processing_Plant_Code
              )
            ) {
              ProcessingList.push({
                key: each.processing_Plant_Code,
                value: each.processing_Plant_Code,
              });
            }
          }
          if (each.packaging_Plant_Code) {
            if (
              !PackagingList.some(
                (item) => item.key === each.packaging_Plant_Code
              )
            ) {
              PackagingList.push({
                key: each.packaging_Plant_Code,
                value: each.packaging_Plant_Code,
              });
            }
          }
          if (each.format) {
            if (!FormatList.some((item) => item.key === each.format)) {
              FormatList.push({ key: each.format, value: each.format });
            }
          }
          if (each.product_Code) {
            if (!productList.some((item) => item.key === each.product_Code)) {
              productList.push({
                key: each.product_Code,
                value: each.product_Code,
              });
            }
          }
          if (each.demand_location_Code) {
            if (
              !DepotList.some((item) => item.key === each.demand_location_Code)
            ) {
              DepotList.push({
                key: each.demand_location_Code,
                value: each.demand_location_Code,
              });
            }
          }
          if (each.plant_Flag) {
            if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
              plantflagList.push({
                key: each.plant_Flag,
                value: each.plant_Flag,
              });
            }
          }
        });
        setVendorList([...vcList]);
        setSFGList([...sfgList]);
        setRMPMList([...RMPMList]);
        setProcessingList([...ProcessingList]);
        setPackagingList([...PackagingList]);
        setFormatList([...FormatList]);
        setProductList([...productList]);

        setDepotList([...DepotList]);
        setFlagList([...plantflagList]);
      })
      .catch((error) => {});
  };
  const vendorChanged = () => {
    let res = [];
    let sfgList = [],
      RMPMList = [],
      ProcessingList = [],
      PackagingList = [],
      FormatList = [],
      productList = [],
      DepotList = [],
      plantflagList = [];
    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        res.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.sfG_Code) {
        if (!sfgList.some((item) => item.key === each.sfG_Code)) {
          sfgList.push({ key: each.sfG_Code, value: each.sfG_Code });
        }
      }

      if (each.rM_PM_MI_Type) {
        if (!RMPMList.some((item) => item.key === each.rM_PM_MI_Type)) {
          RMPMList.push({ key: each.rM_PM_MI_Type, value: each.rM_PM_MI_Type });
        }
      }
      if (each.processing_Plant_Code) {
        if (
          !ProcessingList.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          ProcessingList.push({
            key: each.processing_Plant_Code,
            value: each.processing_Plant_Code,
          });
        }
      }
      if (each.packaging_Plant_Code) {
        if (
          !PackagingList.some((item) => item.key === each.packaging_Plant_Code)
        ) {
          PackagingList.push({
            key: each.packaging_Plant_Code,
            value: each.packaging_Plant_Code,
          });
        }
      }
      if (each.format) {
        if (!FormatList.some((item) => item.key === each.format)) {
          FormatList.push({ key: each.format, value: each.format });
        }
      }
      if (each.product_Code) {
        if (!productList.some((item) => item.key === each.product_Code)) {
          productList.push({
            key: each.product_Code,
            value: each.product_Code,
          });
        }
      }
      if (each.demand_location_Code) {
        if (!DepotList.some((item) => item.key === each.demand_location_Code)) {
          DepotList.push({
            key: each.demand_location_Code,
            value: each.demand_location_Code,
          });
        }
      }
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setSFGSelected([]);
    setRMPMSelected([]);
    setProcessingSelected([]);
    setPackagingSelected([]);
    setFormatSelected([]);
    setProductSelected([]);
    setDepotSelected([]);
    setFlagSelected([]);

    setSFGList([...sfgList]);
    setRMPMList([...RMPMList]);
    setProcessingList([...ProcessingList]);
    setPackagingList([...PackagingList]);
    setFormatList([...FormatList]);
    setProductList([...productList]);
    setDepotList([...DepotList]);
    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };
  const SFGChanged = () => {
    let searchList = [];
    let RMPMList = [],
      ProcessingList = [],
      PackagingList = [],
      FormatList = [],
      productList = [],
      DepotList = [],
      plantflagList = [];
    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (SFGSelected.length === 0) {
        res.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfg_Code)) {
          res.push(each);
        }
      }
    });
    res.forEach((each) => {
      if (each.rM_PM_MI_Type) {
        if (!RMPMList.some((item) => item.key === each.rM_PM_MI_Type)) {
          RMPMList.push({ key: each.rM_PM_MI_Type, value: each.rM_PM_MI_Type });
        }
      }
      if (each.processing_Plant_Code) {
        if (
          !ProcessingList.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          ProcessingList.push({
            key: each.processing_Plant_Code,
            value: each.processing_Plant_Code,
          });
        }
      }
      if (each.packaging_Plant_Code) {
        if (
          !PackagingList.some((item) => item.key === each.packaging_Plant_Code)
        ) {
          PackagingList.push({
            key: each.packaging_Plant_Code,
            value: each.packaging_Plant_Code,
          });
        }
      }
      if (each.format) {
        if (!FormatList.some((item) => item.key === each.format)) {
          FormatList.push({ key: each.format, value: each.format });
        }
      }
      if (each.product_Code) {
        if (!productList.some((item) => item.key === each.product_Code)) {
          productList.push({
            key: each.product_Code,
            value: each.product_Code,
          });
        }
      }
      if (each.demand_location_Code) {
        if (!DepotList.some((item) => item.key === each.demand_location_Code)) {
          DepotList.push({
            key: each.demand_location_Code,
            value: each.demand_location_Code,
          });
        }
      }
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setRMPMSelected([]);
    setProcessingSelected([]);
    setPackagingSelected([]);
    setFormatSelected([]);
    setProductSelected([]);
    setDepotSelected([]);
    setFlagSelected([]);

    setRMPMList([...RMPMList]);
    setProcessingList([...ProcessingList]);
    setPackagingList([...PackagingList]);
    setFormatList([...FormatList]);
    setProductList([...productList]);

    setDepotList([...DepotList]);
    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };
  const RMPMChanged = () => {
    let searchList = [];
    let ProcessingList = [],
      PackagingList = [],
      FormatList = [],
      productList = [],
      DepotList = [],
      plantflagList = [];

    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];

    searchList = [];
    searchList2?.forEach((each) => {
      if (SFGSelected.length === 0) {
        searchList.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfg_Code)) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (RMPMSelected.length === 0) {
        res.push(each);
      } else {
        if (RMPMSelected.some((item) => item.key === each.rM_PM_MI_Type)) {
          res.push(each);
        }
      }
    });
    res.forEach((each) => {
      if (each.processing_Plant_Code) {
        if (
          !ProcessingList.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          ProcessingList.push({
            key: each.processing_Plant_Code,
            value: each.processing_Plant_Code,
          });
        }
      }
      if (each.packaging_Plant_Code) {
        if (
          !PackagingList.some((item) => item.key === each.packaging_Plant_Code)
        ) {
          PackagingList.push({
            key: each.packaging_Plant_Code,
            value: each.packaging_Plant_Code,
          });
        }
      }
      if (each.format) {
        if (!FormatList.some((item) => item.key === each.format)) {
          FormatList.push({ key: each.format, value: each.format });
        }
      }
      if (each.product_Code) {
        if (!productList.some((item) => item.key === each.product_Code)) {
          productList.push({
            key: each.product_Code,
            value: each.product_Code,
          });
        }
      }
      if (each.demand_location_Code) {
        if (!DepotList.some((item) => item.key === each.demand_location_Code)) {
          DepotList.push({
            key: each.demand_location_Code,
            value: each.demand_location_Code,
          });
        }
      }
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setProcessingSelected([]);
    setPackagingSelected([]);
    setFormatSelected([]);
    setProductSelected([]);
    setDepotSelected([]);
    setFlagSelected([]);

    setProcessingList([...ProcessingList]);
    setPackagingList([...PackagingList]);
    setFormatList([...FormatList]);
    setProductList([...productList]);

    setDepotList([...DepotList]);
    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };

  const processingChanged = () => {
    let searchList = [];
    let PackagingList = [],
      FormatList = [],
      productList = [],
      DepotList = [],
      plantflagList = [];

    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];

    searchList = [];
    searchList2?.forEach((each) => {
      if (SFGSelected.length === 0) {
        searchList.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfg_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList3 = [...searchList];
    searchList = [];
    searchList3?.forEach((each) => {
      if (RMPMSelected.length === 0) {
        searchList.push(each);
      } else {
        if (RMPMSelected.some((item) => item.key === each.rM_PM_MI_Type)) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (processingSelected.length === 0) {
        res.push(each);
      } else {
        if (
          processingSelected.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          res.push(each);
        }
      }
    });
    res.forEach((each) => {
      if (each.packaging_Plant_Code) {
        if (
          !PackagingList.some((item) => item.key === each.packaging_Plant_Code)
        ) {
          PackagingList.push({
            key: each.packaging_Plant_Code,
            value: each.packaging_Plant_Code,
          });
        }
      }
      if (each.format) {
        if (!FormatList.some((item) => item.key === each.format)) {
          FormatList.push({ key: each.format, value: each.format });
        }
      }
      if (each.product_Code) {
        if (!productList.some((item) => item.key === each.product_Code)) {
          productList.push({
            key: each.product_Code,
            value: each.product_Code,
          });
        }
      }
      if (each.demand_location_Code) {
        if (!DepotList.some((item) => item.key === each.demand_location_Code)) {
          DepotList.push({
            key: each.demand_location_Code,
            value: each.demand_location_Code,
          });
        }
      }
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setPackagingSelected([]);
    setFormatSelected([]);
    setProductSelected([]);
    setDepotSelected([]);
    setFlagSelected([]);

    setPackagingList([...PackagingList]);
    setFormatList([...FormatList]);
    setProductList([...productList]);

    setDepotList([...DepotList]);
    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };

  const packagingChanged = () => {
    let searchList = [];
    let FormatList = [],
      productList = [],
      DepotList = [],
      plantflagList = [];

    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];

    searchList = [];
    searchList2?.forEach((each) => {
      if (SFGSelected.length === 0) {
        searchList.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfg_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList3 = [...searchList];
    searchList = [];
    searchList3?.forEach((each) => {
      if (RMPMSelected.length === 0) {
        searchList.push(each);
      } else {
        if (RMPMSelected.some((item) => item.key === each.rM_PM_MI_Type)) {
          searchList.push(each);
        }
      }
    });
    let searchList4 = [...searchList];
    searchList = [];
    searchList4?.forEach((each) => {
      if (processingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          processingSelected.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (packagingSelected.length === 0) {
        res.push(each);
      } else {
        if (
          packagingSelected.some(
            (item) => item.key === each.packaging_Plant_Code
          )
        ) {
          res.push(each);
        }
      }
    });
    res.forEach((each) => {
      if (each.format) {
        if (!FormatList.some((item) => item.key === each.format)) {
          FormatList.push({ key: each.format, value: each.format });
        }
      }
      if (each.product_Code) {
        if (!productList.some((item) => item.key === each.product_Code)) {
          productList.push({
            key: each.product_Code,
            value: each.product_Code,
          });
        }
      }
      if (each.demand_location_Code) {
        if (!DepotList.some((item) => item.key === each.demand_location_Code)) {
          DepotList.push({
            key: each.demand_location_Code,
            value: each.demand_location_Code,
          });
        }
      }
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setFormatSelected([]);
    setProductSelected([]);
    setDepotSelected([]);
    setFlagSelected([]);

    setFormatList([...FormatList]);
    setProductList([...productList]);

    setDepotList([...DepotList]);
    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };

  const formatChanged = () => {
    let searchList = [];
    let productList = [],
      DepotList = [],
      plantflagList = [];

    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];

    searchList = [];
    searchList2?.forEach((each) => {
      if (SFGSelected.length === 0) {
        searchList.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfG_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList3 = [...searchList];
    searchList = [];
    searchList3?.forEach((each) => {
      if (RMPMSelected.length === 0) {
        searchList.push(each);
      } else {
        if (RMPMSelected.some((item) => item.key === each.rM_PM_MI_Type)) {
          searchList.push(each);
        }
      }
    });
    let searchList4 = [...searchList];
    searchList = [];
    searchList4?.forEach((each) => {
      if (processingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          processingSelected.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let searchList5 = [...searchList];
    searchList = [];
    searchList5?.forEach((each) => {
      if (packagingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          packagingSelected.some(
            (item) => item.key === each.packaging_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (formatSelected.length === 0) {
        res.push(each);
      } else {
        if (
          formatSelected.some((item) => item.key === each.demand_location_Code)
        ) {
          res.push(each);
        }
      }
    });
    res.forEach((each) => {
      if (each.product_Code) {
        if (!productList.some((item) => item.key === each.product_Code)) {
          productList.push({
            key: each.product_Code,
            value: each.product_Code,
          });
        }
      }
      if (each.demand_location_Code) {
        if (!DepotList.some((item) => item.key === each.demand_location_Code)) {
          DepotList.push({
            key: each.demand_location_Code,
            value: each.demand_location_Code,
          });
        }
      }
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setProductSelected([]);
    setDepotSelected([]);
    setFlagSelected([]);

    setProductList([...productList]);

    setDepotList([...DepotList]);
    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };
  const productChanged = () => {
    let searchList = [];
    let DepotList = [],
      plantflagList = [];

    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];

    searchList = [];
    searchList2?.forEach((each) => {
      if (SFGSelected.length === 0) {
        searchList.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfG_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList3 = [...searchList];
    searchList = [];
    searchList3?.forEach((each) => {
      if (RMPMSelected.length === 0) {
        searchList.push(each);
      } else {
        if (RMPMSelected.some((item) => item.key === each.rM_PM_MI_Type)) {
          searchList.push(each);
        }
      }
    });
    let searchList4 = [...searchList];
    searchList = [];
    searchList4?.forEach((each) => {
      if (processingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          processingSelected.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let searchList5 = [...searchList];
    searchList = [];
    searchList5?.forEach((each) => {
      if (packagingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          packagingSelected.some(
            (item) => item.key === each.packaging_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let searchList6 = [...searchList];
    searchList = [];
    searchList6?.forEach((each) => {
      if (formatSelected.length === 0) {
        searchList.push(each);
      } else {
        if (formatSelected.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (productSelected.length === 0) {
        res.push(each);
      } else {
        if (productSelected.some((item) => item.key === each.product_Code)) {
          res.push(each);
        }
      }
    });
    res.forEach((each) => {
      if (each.demand_location_Code) {
        if (!DepotList.some((item) => item.key === each.demand_location_Code)) {
          DepotList.push({
            key: each.demand_location_Code,
            value: each.demand_location_Code,
          });
        }
      }
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setDepotSelected([]);
    setFlagSelected([]);

    setDepotList([...DepotList]);
    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };
  const depotChanged = () => {
    let searchList = [];
    let plantflagList = [];

    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];

    searchList = [];
    searchList2?.forEach((each) => {
      if (SFGSelected.length === 0) {
        searchList.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfG_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList3 = [...searchList];
    searchList = [];
    searchList3?.forEach((each) => {
      if (RMPMSelected.length === 0) {
        searchList.push(each);
      } else {
        if (RMPMSelected.some((item) => item.key === each.rM_PM_MI_Type)) {
          searchList.push(each);
        }
      }
    });
    let searchList4 = [...searchList];
    searchList = [];
    searchList4?.forEach((each) => {
      if (processingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          processingSelected.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let searchList5 = [...searchList];
    searchList = [];
    searchList5?.forEach((each) => {
      if (packagingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          packagingSelected.some(
            (item) => item.key === each.packaging_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let searchList6 = [...searchList];
    searchList = [];
    searchList6?.forEach((each) => {
      if (formatSelected.length === 0) {
        searchList.push(each);
      } else {
        if (formatSelected.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });
    let searchList7 = [...searchList];
    searchList = [];
    searchList7?.forEach((each) => {
      if (productSelected.length === 0) {
        searchList.push(each);
      } else {
        if (productSelected.some((item) => item.key === each.product_Code)) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (depotSelected.length === 0) {
        res.push(each);
      } else {
        if (
          depotSelected.some((item) => item.key === each.demand_location_Code)
        ) {
          res.push(each);
        }
      }
    });
    res.forEach((each) => {
      if (each.plant_Flag) {
        if (!plantflagList.some((item) => item.key === each.plant_Flag)) {
          plantflagList.push({ key: each.plant_Flag, value: each.plant_Flag });
        }
      }
    });
    setFlagSelected([]);

    setFlagList([...plantflagList]);
    setFilterTableData([...res]);
  };

  const flagChanged = () => {
    let searchList = [];

    resultData?.azureMapsFilterModel?.forEach((each) => {
      if (vendorSelected.length === 0) {
        searchList.push(each);
      } else {
        if (vendorSelected.some((item) => item.key === each.vendor_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];

    searchList = [];
    searchList2?.forEach((each) => {
      if (SFGSelected.length === 0) {
        searchList.push(each);
      } else {
        if (SFGSelected.some((item) => item.key === each.sfG_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList3 = [...searchList];
    searchList = [];
    searchList3?.forEach((each) => {
      if (RMPMSelected.length === 0) {
        searchList.push(each);
      } else {
        if (RMPMSelected.some((item) => item.key === each.rM_PM_MI_Type)) {
          searchList.push(each);
        }
      }
    });
    let searchList4 = [...searchList];
    searchList = [];
    searchList4?.forEach((each) => {
      if (processingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          processingSelected.some(
            (item) => item.key === each.processing_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let searchList5 = [...searchList];
    searchList = [];
    searchList5?.forEach((each) => {
      if (packagingSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          packagingSelected.some(
            (item) => item.key === each.packaging_Plant_Code
          )
        ) {
          searchList.push(each);
        }
      }
    });
    let searchList6 = [...searchList];
    searchList = [];
    searchList6?.forEach((each) => {
      if (formatSelected.length === 0) {
        searchList.push(each);
      } else {
        if (formatSelected.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });
    let searchList7 = [...searchList];
    searchList = [];
    searchList7?.forEach((each) => {
      if (productSelected.length === 0) {
        searchList.push(each);
      } else {
        if (productSelected.some((item) => item.key === each.product_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList8 = [...searchList];
    searchList = [];
    searchList8?.forEach((each) => {
      if (depotSelected.length === 0) {
        searchList.push(each);
      } else {
        if (
          depotSelected.some((item) => item.key === each.demand_location_Code)
        ) {
          searchList.push(each);
        }
      }
    });
    let res = [];
    searchList?.forEach((each) => {
      if (flagSelected.length === 0) {
        res.push(each);
      } else {
        if (flagSelected.some((item) => item.key === each.plant_Flag)) {
          res.push(each);
        }
      }
    });
    setFilterTableData([...res]);
  };
  useEffect(() => {
    vendorChanged();
  }, [vendorSelected]);
  useEffect(() => {
    SFGChanged();
  }, [SFGSelected]);
  useEffect(() => {
    RMPMChanged();
  }, [RMPMSelected]);
  useEffect(() => {
    processingChanged();
  }, [processingSelected]);
  useEffect(() => {
    packagingChanged();
  }, [packagingSelected]);
  useEffect(() => {
    formatChanged();
  }, [formatSelected]);
  useEffect(() => {
    productChanged();
  }, [productSelected]);
  useEffect(() => {
    depotChanged();
  }, [depotSelected]);
  useEffect(() => {
    flagChanged();
  }, [flagSelected]);

  const checkDepotToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].demand_location_Code === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkSupplierToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].vendor_Code === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkPackagingToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].packaging_Plant_Code === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkProcessingToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].processing_Plant_Code === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const getSummaryCostForDashboard = (folderId, scenarioId) => {
    // if (folderId !== 0 || scenarioId !== 0) {
    //   dispatch(displayDashboardSummaryCost());
    //   const urls = API_BASE_URL + LONG_SUMMARY_COST_PER_DASHBOARD_API;
    //   const header = {
    //     accept: "application/json",
    //     "Content-Type": "application/json",
    //   };
    //   getRequest(
    //     urls,
    //     {
    //       folder_id: folderId,
    //       scenario_id: scenarioId,
    //     },
    //     header
    //   )
    //     .then((response) => {
    //       console.log(response?.data, "longtermsummaryData");
    //       dispatch(displayDashboardSummaryCostSuccess(response.data));
    //     })
    //     .catch((error) => {
    //       // dispatch(openErrorDialog(error));
    //       dispatch(displayDashboardSummaryCostError(error.message));
    //     });
    // }
  };

  const nutritionPoints =
    nutritionResultData?.points?.length > 0 ? nutritionResultData?.points : [];

  const points =
    resultData?.azureMapsModel?.points?.length > 0
      ? resultData?.azureMapsModel?.points
      : [];

  const packagingCoords = resultData?.packagingCoords?.length
    ? resultData.packagingCoords
    : [];
  const factoryCoords = resultData?.factoryCoords?.length
    ? resultData.factoryCoords
    : [];

  const nutritionCoordinates =
    nutritionResultData?.coordinates?.length > 0
      ? nutritionResultData?.coordinates
      : [];
  const coordinates =
    resultData?.azureMapsModel?.coordinates?.length > 0
      ? resultData?.azureMapsModel?.coordinates
      : [];

  // {
  //   latitude: 23.0145,
  //   longitude: 72.5918,
  //   text: "Ahmedabad",
  //   title: "Ahmedabad"

  // },
  // {
  //   latitude: 13.4300,
  //   longitude: 77.7200,
  //   text: "Chikkaballapur",
  //   title: "Chikkaballapur"

  // }

  const nutritionPackaging =
    nutritionResultData?.packagingCoords?.length > 0
      ? nutritionResultData?.packagingCoords
      : [];

  const nutritionFactoryCoords =
    nutritionResultData?.factoryCoords?.length > 0
      ? nutritionResultData?.factoryCoords
      : [];

  // const factoryCoords = resultData?.factoryCoords?.length > 0 ? resultData?.factoryCoords : [

  // ];

  // const factoryCoords = [
  //   {
  //     latitude: 23.0145,
  //     longitude: 72.5918,
  //     text: "Ahmedabad",
  //     title: "Ahmedabad",
  //     total: 2000

  //   },
  //   {
  //     latitude: 13.4300,
  //     longitude: 77.7200,
  //     text: "Chikkaballapur",
  //     title: "Chikkaballapur",
  //     total: 5000

  //   },
  //   {
  //     latitude: 30.3647,
  //     longitude: 76.1456,
  //     title: "Rohini Packer",
  //     text: "Rohini Packer",
  //     total: 540
  //   },
  //   {
  //     latitude: 27.786293,
  //     longitude: 81.482357,
  //     title: "Rohini Packer",
  //     text: "Rohini Packer",
  //     total: 1200
  //   }
  // ]

  let popUpContent = [];
  let popupPosition = "";
  function mouseOverLineString(e) {
    popUpContent = [];
    const ele = e.target?.element;
    if (e.target && e.target?.options?.position?.length > 0) {
      console.log(e.target?.options, "contentttt");
      if (e.target?.options?.htmlContent.toString().includes("marker1")) {
        popupPosition = "Depo";
      } else if (
        e.target?.options?.htmlContent.toString().includes("marker2")
      ) {
        popupPosition = "Packaging";
      } else {
        popupPosition = "Factory";
      }
      popUpContent.push(e.target?.options?.position, e.target?.options?.text);
    }
  }

  const onClick = (e) => {
    atlas.Popup(true);
  };

  const eventToMarker = [
    { eventName: "mousemove", callback: mouseOverLineString },
  ];

  const renderPoint = (data) => {
    // if (data.type === "type1") {
    //   return null;
    // }
    let point1 = data.source;
    let point2 = data.destination;
    let out = curvePlot(point1, point2);
    return (
      <AzureMapFeature
        key={"Line String Feature"}
        id={"Line Strign ID"}
        type={"LineString"}
        coordinates={[...out]}
        options={{
          lineJoin: "round",
          //  pathType: 'original',
          lineCap: "round",
          // width: 3,
          // lineDash: [40,10], // <- [dashLength, dashSpace]
          strokeGradient: [
            "interpolate",
            ["linear"],
            ["line-progress"],
            0,
            "#ff00c3",
          ],
        }}
      />
    );
  };

  function renderHTMLPoint() {
    const rendId = Math.random();
    selectedCategoryId === 1
      ? coordinates.map((coordinate, idx) => {
          return (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img className={"marker-1-style"} src={marker1} />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
              events={eventToMarker}
            />
          );
        })
      : nutritionCoordinates?.map((coordinate, idx) => {
          return (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img className={"marker-1-style"} src={marker1} />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
              events={eventToMarker}
            />
          );
        });

    selectedCategoryId === 1
      ? coordinates.map((coordinate, idx) => {
          return (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img className={"marker-1-style"} src={marker1} />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
              events={eventToMarker}
            />
          );
        })
      : nutritionCoordinates?.map((coordinate, idx) => {
          return (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img className={"marker-1-style"} src={marker1} />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
              events={eventToMarker}
            />
          );
        });
    selectedCategoryId === 1
      ? coordinates.map((coordinate, idx) => {
          return (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img className={"marker-1-style"} src={marker1} />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
              events={eventToMarker}
            />
          );
        })
      : nutritionCoordinates?.map((coordinate, idx) => {
          return (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img className={"marker-1-style"} src={marker1} />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
              events={eventToMarker}
            />
          );
        });
  }

  function renderFactoryPoints() {
    const rendId = Math.random();
    setProPlantShow(false);
    setProPlantAddShow(false);
    setProPlantRemoveShow(false);
    setProPlantCapacityAddShow(false);
    return (
      // {/* {selectedCategoryId === 1 ? <> */}
      true
        ? // {/* {factoryCoords.map((coordinate, idx) => { */}
          resultData &&
            resultData?.azureMapsModel?.factoryCoords &&
            resultData?.azureMapsModel?.factoryCoords.map((coordinate, idx) => {
              let factFlag = coordinate.capacityflag;
              let coText = coordinate.text;
              let ppText = "Processing Plant: ";
              let imgClrFlag;

              switch (factFlag) {
                case "Existing": // processing plant
                  setProPlantShow(true);
                  if (proPlant) {
                    imgClrFlag = processingPlant;
                  } else {
                    coText = "";
                    ppText = "";
                  }

                  break;
                case "New": // new processing plant
                  setProPlantAddShow(true);
                  if (proPlantAdd) {
                    imgClrFlag = processingPlantAdd;
                  } else {
                    coText = "";
                    ppText = "";
                  }

                  break;
                case "Closure": // Closed Processing Plan
                  setProPlantRemoveShow(true);
                  if (proPlantRemove) {
                    imgClrFlag = processingPlantRemove;
                  } else {
                    coText = "";
                    ppText = "";
                  }

                  break;
                case "Capacity Increment": // Processing Plant Capacity Add
                  setProPlantCapacityAddShow(true);
                  if (proPlantCapacityAdd) {
                    imgClrFlag = processingPlantCapacity;
                  } else {
                    coText = "";
                    ppText = "";
                  }

                  break;
                case "Potential":
                  imgClrFlag = processingPlant;
                  break;
                default:
                  imgClrFlag = processingPlant;
              }

              return checkProcessingToShow(coordinate) ? (
                <AzureMapHtmlMarker
                  key={idx}
                  markerContent={
                    // <div title={coordinate.title}>
                    //   {/* <img className={"marker-3-style"} src={marker3} onMouseEnter={mouseOverLineString} /> */}
                    //   <div style={{
                    //     width: valueToWidth(coordinate.total, coordinate.text) + "px",
                    //     height: valueToWidth(coordinate.total, coordinate.text) + "px",
                    //     fontSize: valueToFont(coordinate.total) + "px"
                    //   }} className={"bubble-in-map plants"}>
                    //     {coordinate.total}
                    //   </div>
                    // </div>
                    <div>
                      <img
                        className={"marker-3-style2"}
                        src={imgClrFlag ? imgClrFlag : ""}
                        title={ppText + coText}
                      />
                    </div>
                  }
                  options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                  events={[
                    {
                      eventName: "click",
                      callback: () =>
                        mapPointClicked(
                          coordinate,
                          "Processing Plant",
                          imgClrFlag
                        ),
                    },
                  ]}
                />
              ) : null;
            })
        : nutritionFactoryCoords?.map((coordinate, idx) => {
            {
              /* {resultData && resultData?.factoryCoords && resultData?.factoryCoords.map((coordinate, idx) => { */
            }
            return (
              <AzureMapHtmlMarker
                key={idx}
                markerContent={
                  <div>
                    <img
                      className={"marker-3-style"}
                      src={marker3}
                      title={"Processing Plant: " + coordinate.text}
                    />
                  </div>
                }
                options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                events={[
                  {
                    eventName: "click",
                    callback: () =>
                      mapPointClicked(coordinate, "Packaging Plant"),
                  },
                ]}
              />
            );
          })
    );
  }

  function renderPackagingPoints() {
    const rendId = Math.random();
    setPackPlantShow(false);
    setPackPlantAddShow(false);
    setPackPlantRemoveShow(false);
    setPackPlantCapacityAddShow(false);
    return (
      <>
        {/* {selectedCategoryId === 1 ? <> */}
        {true ? (
          <>
            {/* {factoryCoords.map((coordinate, idx) => { */}
            {resultData &&
              resultData?.azureMapsModel?.packagingCoords &&
              resultData?.azureMapsModel?.packagingCoords.map(
                (coordinate, idx) => {
                  let factFlag = coordinate.capacityflag;
                  let coText = coordinate.text;
                  let ppText = "Packaging Plant: ";
                  let imgClrFlag;

                  switch (factFlag) {
                    case "Existing": //  packaging plant
                      setPackPlantShow(true);
                      if (packPlant) {
                        imgClrFlag = packagingPlant1;
                      } else {
                        coText = "";
                        ppText = "";
                      }

                      break;
                    case "New": // new packaging plant
                      setPackPlantAddShow(true);
                      if (packPlantAdd) {
                        imgClrFlag = packagingPlant2;
                      } else {
                        coText = "";
                        ppText = "";
                      }

                      break;
                    case "Closure": // closed pack plant
                      setPackPlantRemoveShow(true);
                      if (packPlantRemove) {
                        imgClrFlag = packagingPlantRemove;
                      } else {
                        coText = "";
                        ppText = "";
                      }

                      break;
                    case "Capacity Increment": // Packaging Plant Capacity Add
                      setPackPlantCapacityAddShow(true);
                      if (packPlantCapacityAdd) {
                        imgClrFlag = packagingPlantCapacity;
                      } else {
                        coText = "";
                        ppText = "";
                      }

                      break;
                    case "Potential":
                      imgClrFlag = packagingPlant1;
                      break;
                    default:
                      imgClrFlag = packagingPlant1;
                  }
                  return checkPackagingToShow(coordinate) ? (
                    <AzureMapHtmlMarker
                      key={idx}
                      markerContent={
                        // <div title={coordinate.title}>
                        //   {/* <img className={"marker-3-style"} src={marker3} onMouseEnter={mouseOverLineString} /> */}
                        //   <div style={{
                        //     width: valueToWidth(coordinate.total, coordinate.text) + "px",
                        //     height: valueToWidth(coordinate.total, coordinate.text) + "px",
                        //     fontSize: valueToFont(coordinate.total) + "px"
                        //   }} className={"bubble-in-map plants"}>
                        //     {coordinate.total}
                        //   </div>
                        // </div>
                        <div>
                          <img
                            className={"marker-3-style2"}
                            src={imgClrFlag ? imgClrFlag : ""}
                            title={ppText + coText}
                            // src={imgClrFlag}
                            // title={'Packaging Plant: ' + coordinate.text}
                          />
                        </div>
                      }
                      options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                      events={[
                        {
                          eventName: "click",
                          callback: () =>
                            mapPointClicked(
                              coordinate,
                              "Packaging Plant",
                              imgClrFlag
                            ),
                        },
                      ]}
                    />
                  ) : null;
                }
              )}
          </>
        ) : (
          <>
            {nutritionFactoryCoords?.map((coordinate, idx) => {
              {
                /* {resultData && resultData?.factoryCoords && resultData?.factoryCoords.map((coordinate, idx) => { */
              }
              return (
                <AzureMapHtmlMarker
                  key={idx}
                  markerContent={
                    <div>
                      <img
                        className={"marker-3-style"}
                        src={packagingPlant1}
                        // onMouseEnter={mouseOverLineString}
                      />
                    </div>
                  }
                  options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                  events={eventToMarker}
                />
              );
            })}
          </>
        )}
      </>
    );
  }

  function renderSuppliers() {
    const rendId = Math.random();
    setSupplierShow(false);
    if (resultData?.azureMapsModel?.suppliers?.length > 0) {
      setSupplierShow(true);
    }
    return (
      <>
        {/* {selectedCategoryId === 1 ? <> */}
        {true ? (
          <>
            {/* {factoryCoords.map((coordinate, idx) => { */}
            {resultData &&
              resultData?.azureMapsModel?.suppliers &&
              resultData?.azureMapsModel?.suppliers.map((coordinate, idx) => {
                return checkSupplierToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      // <div title={coordinate.title}>
                      //   {/* <img className={"marker-3-style"} src={marker3} onMouseEnter={mouseOverLineString} /> */}
                      //   <div style={{
                      //     width: valueToWidth(coordinate.total, coordinate.text) + "px",
                      //     height: valueToWidth(coordinate.total, coordinate.text) + "px",
                      //     fontSize: valueToFont(coordinate.total) + "px"
                      //   }} className={"bubble-in-map plants"}>
                      //     {coordinate.total}
                      //   </div>
                      // </div>
                      <div>
                        <img
                          className={"marker-3-style2"}
                          src={suppliersIcon}
                          title={"Supplier: " + coordinate.text}
                        />
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={[
                      {
                        eventName: "click",
                        callback: () =>
                          mapPointClicked(
                            coordinate,
                            "Supplier",
                            suppliersIcon
                          ),
                      },
                    ]}
                  />
                ) : null;
              })}
          </>
        ) : (
          <>
            {nutritionFactoryCoords?.map((coordinate, idx) => {
              {
                /* {resultData && resultData?.factoryCoords && resultData?.factoryCoords.map((coordinate, idx) => { */
              }
              return (
                <AzureMapHtmlMarker
                  key={idx}
                  markerContent={
                    <div>
                      <img
                        className={"marker-3-style"}
                        src={packagingPlant1}
                        // onMouseEnter={mouseOverLineString}
                      />
                    </div>
                  }
                  options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                  events={eventToMarker}
                />
              );
            })}
          </>
        )}
      </>
    );
  }

  function renderDepotPoints() {
    const rendId = Math.random();
    setDepotShow(false);
    if (resultData?.azureMapsModel?.coordinates?.length > 0) {
      setDepotShow(true);
    }
    return (
      <>
        {/* {selectedCategoryId === 1 ? <> */}

        {/* {depotCoords.map((coordinate, idx) => { */}
        {resultData &&
          resultData?.azureMapsModel?.coordinates &&
          resultData?.azureMapsModel?.coordinates.map((coordinate, idx) => {
            return checkDepotToShow(coordinate) ? (
              <AzureMapHtmlMarker
                key={idx}
                markerContent={
                  <div>
                    <img
                      className={"marker-3-style"}
                      src={locator}
                      title={"Depot: " + coordinate.text}
                    />
                  </div>
                }
                options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                events={[
                  {
                    eventName: "click",
                    callback: () =>
                      mapPointClicked(coordinate, "Depot", locator),
                  },
                ]}
              />
            ) : null;
          })}
      </>
    );
  }

  function azureHtmlMapMarkerOptions(coordinate) {
    // console.log(coordinate);
    return {
      //position: [coordinate.latitude, coordinate.longitude],
      position: [coordinate.longitude, coordinate.latitude],
      text: coordinate.text,
      title: coordinate.title,
    };
  }

  const curvePlot = (point1, point2) => {
    let startX = point1[0];
    let startY = point1[1];

    let endX = point2[0];
    let endY = point2[1];

    let centerX = (startX + endX) / 2;
    let centerY = (startY + endY) / 2;

    let slope = (endY - startY) / (endX - startX);
    let c1 = endY - slope * endX;
    let nslope = (1 / slope) * -1;
    let c = slope * centerX + centerX / slope + c1; //c for perpendicular line
    //eq of perpendicular line : y = (-1/slope)x + c

    //Now solve quadratic eq: ax2 + bx + c2 = 0
    let a = 1 + nslope * nslope;
    let b = 2 * nslope * c - 2 * centerX - 2 * nslope * centerY;
    let c2 =
      centerX * centerX + centerY * centerY + c * c - 2 * centerY * c - 2;

    let reqX = (-b - Math.sqrt(Math.abs(b * b - 4 * a * c2))) / (2 * a);
    let reqY = nslope * reqX + c;

    let out = [];
    out.push(point1);

    let bezierX = reqX;
    let bezierY = reqY;

    // for (let t = 0.0; t <= 1; t += 0.01) {
    //   let x =
    //     (1 - t) * (1 - t) * startX + 2 * (1 - t) * t * bezierX + t * t * endX;
    //   let y =
    //     (1 - t) * (1 - t) * startY + 2 * (1 - t) * t * bezierY + t * t * endY;
    //   out.push([x, y]);
    // }
    out.push(point2);
    return out;
  };
  console.log(curvePlot, "curvePlot");
  // curvePlot?.setProperty('strokeColor', 'red')

  const renderMarker = () => {
    const rendId = Math.random();

    return (
      <AzureMapFeature
        key={rendId}
        id={rendId.toString()}
        type="Point"
        coordinate={coordinates}
        nutritionPackaging={nutritionPackaging}
        // state = {states}
        properties={{
          title: "Pin",
          icon: "pin-round-blue",
        }}
      />
    );
  };

  const calculateDistance = (point1, point2) => {
    let dis =
      Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2);
    return Math.sqrt(dis);
  };

  const resetFilter = async () => {
    await getAzureMapData(selectedFolderId, selectedScnarioId);
    setVendorSelected([]);
    setSFGSelected([]);
    setRMPMSelected([]);
    setProcessingSelected([]);
    setPackagingSelected([]);
    setFormatSelected([]);
    setProductSelected([]);
    setDepotSelected([]);
    setFlagSelected([]);
  };

  const renderLegendOptions = () => {
    return (
      <div className="CGOlegends-panel LongTerm-Legends-Panel">
        {/* <h3>Showing</h3> */}
        <br></br>
        {proPlantShow && (
          <ul>
            <li>
              <img src={processingPlant}></img>
            </li>
            <li>
              <span>Processing Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlant}
                onChange={(v) => handleProPlant(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}
        {proPlantAddShow && (
          <ul>
            <li>
              <img src={processingPlantAdd}></img>
            </li>
            <li>
              <span>New Processing Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlantAdd}
                onChange={(v) => handleProPlantAdd(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}
        {proPlantCapacityAddShow && (
          <ul>
            <li>
              <img src={processingPlantCapacity}></img>
            </li>
            <li>
              <span>Processing Plant Capacity Add</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlantCapacityAdd}
                onChange={(v) => handleProPlantCapacityAdd(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}

        {proPlantRemoveShow && (
          <ul>
            <li>
              <img src={processingPlantRemove}></img>
            </li>
            <li>
              <span>Closed Processing Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlantRemove}
                onChange={(v) => handleProPlantRemove(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}

        {/* <ul>
          <li><div className='depots'></div></li>
          <li><span>Depots</span></li>
          <li><input checked={show2} onChange={v => setShow2(v.target.checked)} type="checkbox" className="pull-right" /></li>
        </ul> */}
        {packPlantShow && (
          <ul>
            <li>
              <img src={packagingPlant1}></img>
            </li>
            <li>
              <span>Packaging Plant</span>
            </li>
            <li>
              <input
                checked={packPlant}
                onChange={(v) => handlePackPlant(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}
        {/* <ul>
          <li>
            <img src={packagingPlant1}></img>
          </li>
          <li>
            <span>Packaging Plant</span>
          </li>
          <li>
            <input
              checked={packPlant}
              onChange={(v) => handlePackPlant(v)}
              type="checkbox"
              className="pull-right"
            />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlant1}></img>
          </li>
          <li>
            <span>Packaging Plant</span>
          </li>
          <li>
            <input
              checked={packPlant}
              onChange={(v) => handlePackPlant(v)}
              type="checkbox"
              className="pull-right"
            />
          </li>
        </ul> */}
        {packPlantAddShow && (
          <ul>
            <li>
              <img src={packagingPlant2}></img>
            </li>
            <li>
              <span>New Packaging Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={packPlantAdd}
                onChange={(v) => handlePackPlantAdd(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}

        {packPlantCapacityAddShow && (
          <ul>
            <li>
              <img src={packagingPlantCapacity}></img>
            </li>
            <li>
              <span>Packaging Plant Capacity Add</span>
            </li>
            <li></li>
            <li>
              <input
                checked={packPlantCapacityAdd}
                onChange={(v) => handlePackPlantCapacityAdd(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}
        {packPlantRemoveShow && (
          <ul>
            <li>
              <img src={packagingPlantRemove}></img>
            </li>
            <li>
              <span>Closed Packaging Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={packPlantRemove}
                onChange={(v) => handlePackPlantRemove(v)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}
        {depotShow && (
          <ul>
            <li className="margin5">
              <img src={locator}></img>
            </li>
            <li className="margin3">
              <span>Depots</span>
            </li>
            <li>
              <input
                checked={show3}
                onChange={(v) => setShow3(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}

        {supplierShow && (
          <ul>
            <li className="margin3">
              <img src={suppliersIcon}></img>
            </li>
            <li className="margin0">
              <span>Suppliers</span>
            </li>
            <li>
              <input
                checked={show4}
                onChange={(v) => setShow4(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}

        <ul className="">
          <li>
            <span className="barliine text-red">____</span>
          </li>
          <li className="">
            <span>In-bound to packaging plant from Processing plant</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul className="">
          <li>
            <span className="barliine">____</span>
          </li>
          <li className="">
            <span>In-bound to Depot from Packaging</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
      </div>
    );
  };

  <AzureMapFeature
    key={data.licensePlate}
    id={data.licensePlate}
    type="Point"
    coordinate={data}
    packaging={data}
    state={data}
    properties={{
      id: data.licensePlate,
      popUpProp: data,
    }}
  />;

  const MarkersExample = () => {
    const [popupProperties, setPopupProperties] = useState("");
    const [popupOptions, setPopupOptions] = useState({});
    const option = useMemo(() => {
      return {
        authOptions: {
          authType: AuthenticationType.subscriptionKey,
          subscriptionKey: key,
        },
        center: [77.580643, 20.972442],
        zoom: 3.4,
        view: "Auto",
        visibility: "off",
      };
    }, []);

    var popup = new atlas.Popup({});
    const mapRef = useRef(null);

    const handleZoom = (e) => {
      const zoomLevel = e?.map?.map?.getZoom();
      console.log("zoomLevel", zoomLevel);
      if (zoomLevel > 0) {
        let layers = e?.map?.map?.getStyle().layers;

        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == "symbol" &&
            layers[i].source == "vectorTiles" &&
            layers[i].layout &&
            layers[i].layout["text-field"] &&
            layers[i].layout["text-field"] !== ""
          ) {
            e?.map?.map?.setLayoutProperty(layers[i].id, "visibility", "none");
          }
        }
      } else {
        let layers = e?.map?.map?.getStyle().layers;
        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == "symbol" &&
            layers[i].source == "vectorTiles" &&
            layers[i].layout &&
            layers[i].layout["text-field"] &&
            layers[i].layout["text-field"] !== ""
          ) {
            e?.map?.map.setLayoutProperty(layers[i].id, "visibility", "none");
          }
        }
      }
    };
    useEffect(() => {
      // console.log(popupOptions, "popupOptions")
    }, [popupOptions]);

    const memoizedMarkerRender = useMemo(
      () =>
        points
          ?.filter((each) => {
            if (each.type === "type1") {
              if (
                vendorSelected.length === 0 &&
                processingSelected.length === 0 &&
                packagingSelected.length === 0 &&
                depotSelected.length === 0 &&
                SFGSelected.length === 0 &&
                RMPMSelected.length === 0 &&
                formatSelected.length === 0 &&
                productSelected.length === 0 &&
                flagSelected.length === 0
              ) {
                return each;
              } else {
                let flag1 = false,
                  flag2 = false,
                  flag3 = false,
                  flag4 = false,
                  flag5 = false,
                  flag6 = false,
                  flag7 = false;
                filterTableData.forEach((e) => {
                  if (e.processing_Plant_Code === each.factorycode) {
                    flag1 = true;
                  }
                  if (e.demand_location_Code === each.depotcode) {
                    flag2 = true;
                  }
                  if (e.packaging_Plant_Code === each.factorycode) {
                    flag3 = true;
                  }
                  if (e.packaging_Plant_Code === each.depotcode) {
                    flag4 = true;
                  }
                  if (e.vendor_Code === each.factorycode) {
                    flag5 = true;
                  }
                  if (e.packaging_Plant_Code === each.depotcode) {
                    flag6 = true;
                  }
                  if (e.processing_Plant_Code === each.depotcode) {
                    flag7 = true;
                  }
                });

                if (flag1 && flag2) {
                  return each;
                }
                if (flag2 && flag3) {
                  return each;
                }
                if (flag1 && flag4) {
                  return each;
                }
                if (flag5 && flag6) {
                  return each;
                }
                if (flag5 && flag7) {
                  return each;
                }
              }
            }
          })
          .map((el) => renderPoint(el)),
      []

      // () => points?.filter((each) => {
      //   if (each.factory_Code === selectedFactory) {
      //     return each;
      //   } else if (selectedFactory === "Factory") {
      //     return each;
      //   }
      // })
      //   ?.filter((each) => each.type === 'type1')
      //   .map((el) => renderPoint(el)),
      // []
    );

    const memoizedMarkerRender2 = useMemo(
      () =>
        points
          ?.filter((each) => {
            if (each.type === "type2") {
              if (
                vendorSelected.length === 0 &&
                processingSelected.length === 0 &&
                packagingSelected.length === 0 &&
                depotSelected.length === 0 &&
                SFGSelected.length === 0 &&
                RMPMSelected.length === 0 &&
                formatSelected.length === 0 &&
                productSelected.length === 0 &&
                flagSelected.length === 0
              ) {
                return each;
              } else {
                let flag1 = false,
                  flag2 = false,
                  flag3 = false,
                  flag4 = false,
                  flag5 = false,
                  flag6 = false,
                  flag7 = false;
                filterTableData.forEach((e) => {
                  if (e.processing_Plant_Code === each.factorycode) {
                    flag1 = true;
                  }
                  if (e.demand_location_Code === each.depotcode) {
                    flag2 = true;
                  }
                  if (e.packaging_Plant_Code === each.factorycode) {
                    flag3 = true;
                  }
                  if (e.packaging_Plant_Code === each.depotcode) {
                    flag4 = true;
                  }
                  if (e.vendor_Code === each.factorycode) {
                    flag5 = true;
                  }
                  if (e.packaging_Plant_Code === each.depotcode) {
                    flag6 = true;
                  }
                  if (e.processing_Plant_Code === each.depotcode) {
                    flag7 = true;
                  }
                });

                if (flag1 && flag2) {
                  return each;
                }
                if (flag2 && flag3) {
                  return each;
                }

                if (flag5 && flag6) {
                  return each;
                }
                if (flag5 && flag7) {
                  return each;
                }
                if (flag1 && flag4) {
                  return each;
                }
              }
            }
          })
          .map((el) => renderPoint(el)),
      []

      // () => points?.filter((each) => {
      //   if (each.factory_Code === selectedFactory) {
      //     return each;
      //   } else if (selectedFactory === "Factory") {
      //     return each;
      //   }
      // })
      //   ?.filter((each) => each.type === 'type2')
      //   .map((el) => renderPoint(el)),
      // []
    );

    const nutritionMemoizedMarkerRender = useMemo(
      () => nutritionPoints?.map((el) => renderPoint(el)),
      []
    );

    console.log(nutritionPoints, "nutritionPoints");

    const wrapperStyles = {
      map: {
        height: "700px",
        width: "100%",
      },
      wrapper: {
        padding: "15px",
        marginTop: "15px",
      },
      buttonContainer: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: "10px",
        gridAutoColumns: "max-content",
        padding: "10px 0",
      },
      buttons: {
        padding: "15px",
        flex: 1,
      },
      popupStyles: {
        padding: "20px",
        color: "black",
      },
    };

    return (
      <>
        <AzureMapsProvider>
          <div style={wrapperStyles.map}>
            <AzureMap
              events={{
                wheel: (e) => {
                  console.log("zoooooom", e?.map?.map?.getZoom());
                  let z = e?.map?.map?.getZoom();
                },
              }}
              options={option}
            >
              <AzureMapDataSourceProvider
                events={{
                  dataadded: (e) => {
                    //    console.log("Data on source added", e);
                  },
                }}
                id={"routeExample AzureMapDataSourceProvider"}
                options={{
                  // This sample shows how to apply a stroke gradient to a line on the map.\
                  // In order to apply this feature to a line, the data source must have the lineMetrics option set to true.
                  lineMetrics: true,
                }}
              >
                <AzureMapLayerProvider
                  id={"routeExample AzureMapLayerProvider"}
                  options={{
                    lineJoin: "round",
                    //  pathType: 'original',
                    lineCap: "round",
                    // width: 3,
                    // lineDash: [40,10], // <- [dashLength, dashSpace]
                    strokeGradient: [
                      "interpolate",
                      ["linear"],
                      ["line-progress"],
                      0,
                      "#73706E",
                    ],
                    strokeWidth: 0.8,
                  }}
                  events={{
                    mouseOverLineString: (e) => {},
                    wheel: (e) => {
                      handleZoom(e);
                    },
                    mouseleave: () => {
                      setPopupOptions(() => {});
                    },

                    mousemove: (e) => {
                      return;
                      if (e.shapes && e.shapes.length > 0) {
                        const prop = e.target?.options;

                        setPopupOptions({
                          ...popupOptions,
                          position: new data.Position(
                            e?.position[0],
                            e?.position[1]
                          ),
                          pixelOffset: [0, -8],
                        });
                        setPopupProperties("Position: " + popupPosition);

                        if (prop?.text)
                          setPopupProperties([...popupProperties, prop?.text]);
                      }
                    },
                  }}
                  lifecycleEvents={{
                    layeradded: (e) => {
                      //     console.log("LAYER ADDED TO MAP", e);
                    },
                  }}
                  type={"LineLayer"}
                />
                {proPlant &&
                  proPlantAdd &&
                  proPlantCapacityAdd &&
                  proPlantRemove &&
                  packPlant &&
                  packPlantAdd &&
                  packPlantCapacityAdd &&
                  packPlantRemove &&
                  show3 &&
                  show4 &&
                  memoizedMarkerRender}

                {/* {map1Render} */}
                {/* {renderHTMLPoint()} */}
                {show1 ? renderFactoryPoints() : null}
                {show2 ? renderPackagingPoints() : null}
                {show3 ? renderDepotPoints() : null}
                {show4 ? renderSuppliers() : null}
                {/* {show1 && show2 && show3 && show4 && memoizedMarkerRender} */}
                {/* {show1 && proPlant && proPlantAdd && proPlantCapacityAdd && proPlantRemove && show2 && show3 && show4 && memoizedMarkerRender} */}
                {/* {show1 && show2 && show3 && memoizedMarkerRender2} */}
              </AzureMapDataSourceProvider>

              <AzureMapDataSourceProvider
                events={{
                  dataadded: (e) => {
                    //    console.log("Data on source added", e);
                  },
                }}
                id={"routeExample AzureMapDataSourceProvider2"}
                options={{
                  // This sample shows how to apply a stroke gradient to a line on the map.\
                  // In order to apply this feature to a line, the data source must have the lineMetrics option set to true.
                  lineMetrics: true,
                }}
              >
                <AzureMapLayerProvider
                  id={"routeExample AzureMapLayerProvider2"}
                  options={{
                    lineJoin: "round",
                    //  pathType: 'original',
                    width: 1,
                    lineCap: "round",
                    // width: 3,
                    // lineDash: [40,10], // <- [dashLength, dashSpace]
                    strokeGradient: [
                      "interpolate",
                      ["linear"],
                      ["line-progress"],
                      0,
                      "#ff00c3",
                    ],
                    strokeWidth: 0.8,
                  }}
                  events={{
                    mouseOverLineString: (e) => {},
                    wheel: (e) => {
                      handleZoom(e);
                    },
                    mouseleave: () => {
                      setPopupOptions(() => {});
                    },

                    mousemove: (e) => {
                      return;
                      if (e.shapes && e.shapes.length > 0) {
                        const prop = e.target?.options;

                        setPopupOptions({
                          ...popupOptions,
                          position: new data.Position(
                            e?.position[0],
                            e?.position[1]
                          ),
                          pixelOffset: [0, -8],
                        });
                        setPopupProperties("Position: " + popupPosition);

                        if (prop?.text)
                          setPopupProperties([...popupProperties, prop?.text]);
                      }
                    },
                  }}
                  lifecycleEvents={{
                    layeradded: (e) => {
                      //     console.log("LAYER ADDED TO MAP", e);
                    },
                  }}
                  type={"LineLayer"}
                />

                {/* {map1Render} */}
                {/* {renderHTMLPoint()} */}

                {proPlant &&
                  proPlantAdd &&
                  proPlantCapacityAdd &&
                  proPlantRemove &&
                  packPlant &&
                  packPlantAdd &&
                  packPlantCapacityAdd &&
                  packPlantRemove &&
                  show3 &&
                  show4 &&
                  memoizedMarkerRender2}
              </AzureMapDataSourceProvider>

              <AzureMapPopup
                isVisible={popupOptions ? true : false}
                options={popupOptions}
                popupContent={
                  <>
                    <div style={{ padding: "8px" }}>
                      <span>
                        {popupProperties}
                        <br /> City: {popUpContent[1]}
                      </span>
                    </div>
                  </>
                }
              />
            </AzureMap>
          </div>
        </AzureMapsProvider>
      </>
    );
  };
  return (
    <div className="App">
      <div
        className="map-filters"
        onClick={() => {
          setViewDetail(false);
          setshowMapFiltersDetails(true);
          setshowLegendDetails(false);
        }}
      >
        {/* <div className="map-filters"> */}
        <span className="direction-symbol">&#171; &nbsp;</span>
        <span>Map Filter</span>
      </div>

      {showMapFiltersDetails && (
        <div className="map-filter-panel">
          <div className="header">
            {!viewDetail ? (
              <>
                <span className="pull-left">
                  <h2>Map Filter</h2>
                </span>
                <span onClick={() => resetFilter()}>
                  <RestoreOutlinedIcon className="restoreIcon1" />
                </span>
                <span className="pull-right">
                  <a
                    href="#"
                    className="collapse-btn"
                    onClick={() => {
                      setshowMapFiltersDetails(false);
                      resetFilter();
                    }}
                  >
                    Collapse&nbsp; &#187;
                  </a>
                </span>
              </>
            ) : null}
          </div>
          <div className="clear"></div>

          {!viewDetail ? (
            <div className="filters">
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  value={vendorSelected}
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={vendorList}
                  limitTags={1}
                  onChange={(e, item) => {
                    setVendorSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.key}
                  renderOption={(props, option, { selected }) => {
                    return (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option.key}
                      </li>
                    );
                  }}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Vendor"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={SFGList}
                  value={SFGSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setSFGSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="SFG"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={RMPMList}
                  value={RMPMSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setRMPMSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="RMPM"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={processingList}
                  value={processingSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setProcessingSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Processing"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={packagingList}
                  value={packagingSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setPackagingSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Packaging"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={formatList}
                  value={formatSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setFormatSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option: any) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Format"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={productList}
                  value={productSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setProductSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option: any) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Product"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={depotList}
                  value={depotSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setDepotSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option: any) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Depot"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
              <FormControl sx={{ width: 200 }}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo-new"
                  options={flagList}
                  value={flagSelected}
                  limitTags={1}
                  onChange={(e, item) => {
                    setFlagSelected(item);
                  }}
                  autoComplete
                  includeInputInList
                  disableCloseOnSelect
                  getOptionLabel={(option: any) => option.key}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.key}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Filter 1"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
            </div>
          ) : (
            <div className="sidePanel-title">
              <div className="pull-left">
                <h2 className="sidepanel-header">{currentDetail.heading}</h2>
                <img
                  src={
                    currentDetail.imgUrl
                      ? currentDetail.imgUrl
                      : processingPlant
                  }
                  className="title-icon"
                ></img>
                <span className="text-indent">{currentDetail.text}</span>
                <span>|</span>
                <span>{currentDetail.title}</span>
                <span>|</span>
                <span>
                  {currentDetail.latitude}, {currentDetail.longitude}
                </span>
              </div>
              <div className="pull-right">
                <span
                  onClick={() => {
                    setshowMapFiltersDetails(false);
                    setViewDetail(false);
                    resetFilter();
                  }}
                >
                  <a className="collapse-btn1">
                    Exit <span className="small-font">&#10060;</span>
                  </a>
                </span>
              </div>
            </div>
          )}
          <br></br>
          <div className="filter-dataTable scrollbar">
            <table cellPadding={0} cellSpacing={0}>
              <tr>
                <th>Vendor Code</th>
                <th>Vendor Description</th>
                <th>RMPMMI Type</th>
                <th>RMPMMI Description</th>
                <th>Processing Plant Code</th>
                <th>Processing Plant Description</th>
                <th>SFG Code</th>
                <th>SFG Description</th>
                <th>Packaging plant Code</th>
                <th>Packaging Plant Description</th>
                <th>Format</th>
                <th>Demand Location Code</th>
                <th>Demand Location Description</th>
                <th>Product Code</th>
                <th>Product Description</th>
                <th>Flow Volume</th>
                <th>Plant Flag</th>
              </tr>
              {/* <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr> */}
              {filterTableData.map((each, idx) => (
                <tr key={idx}>
                  <td>{each.vendor_Code}</td>
                  <td>{each.vendor_Description}</td>
                  <td>{each.rM_PM_MI_Type}</td>
                  <td>{each.rM_PM_MI_Description}</td>
                  <td>{each.processing_Plant_Code}</td>
                  <td>{each.processing_Plant_Description}</td>
                  <td>{each.sfG_Code}</td>
                  <td>{each.sfG_Description}</td>
                  <td>{each.packaging_Plant_Code}</td>
                  <td>{each.packaging_Plant_Description}</td>
                  <td>{each.format}</td>
                  <td>{each.demand_location_Code}</td>
                  <td>{each.demand_location_Code}</td>
                  <td>{each.product_Code}</td>
                  <td>{each.product_Description}</td>
                  <td>{each.flow_Volume}</td>
                  <td>{each.plant_Flag}</td>
                </tr>
              ))}
            </table>
          </div>
          <br></br>
        </div>
      )}
      {/* legends info */}
      <div className="map-legend" onClick={() => setshowLegendDetails(true)}>
        {/* <span><img src={locator} ></img></span> */}
        <span className="direction-symbol">&#171; &nbsp;</span>
        <span>Legend</span>
        {showLegendDetails && (
          <span
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              setshowLegendDetails(false);
            }}
          >
            &nbsp;&#10060;
          </span>
        )}
      </div>

      {showLegendDetails && renderLegendOptions()}

      <div className="over">
        <MarkersExample />
      </div>
    </div>
  );
}
